export const SmartFilterRepository = Symbol('SmartFilterRepository');
